<template>
  <div>

    <div class="card border-0 shadow-sm mt-3 mb-3">
      <div class="card-body">

        <button v-if="!cart.shipping_address.name" type="button" class="btn btn-primary" style="position:relative;top:-2px;" @click.prevent="promptCustomerInformation">
          <i class="fas fa-user mr-1"></i> Add customer information
        </button>

        <template v-else>
          <h5 class="d-inline-block mb-0">
            <i class="fas fa-user mr-2"></i> {{ cart.shipping_address.name }}
            <span v-if="cart.shipping_address.city" class="text-muted small">&middot; {{ cart.shipping_address.city.name }}</span>
            <span v-if="cart.shipping_address.telephone" class="text-muted small">&middot; {{ cart.shipping_address.telephone }}</span>
          </h5>
          <button type="button" class="btn btn-outline-primary ml-2" style="position:relative;top:-2px;" @click.prevent="promptCustomerInformation"><i class="fas fa-edit"></i></button>
        </template>

        <div v-if="channels" class="d-inline-block ml-2">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">Channel</span>
            </div>
            <select v-model="cart.channel_id" class="form-control" @change="saveChannel" :disabled="processing_channel">
              <option v-for="(channel,k) in channels" :key="k" :value="channel.id">{{ channel.name }}</option>
            </select>
            <button class="btn btn-light" v-if="processing_channel">
              <i class="fas fa-circle-notch fa-spin"></i>
            </button>
          </div>
        </div>

      </div>
    </div>

    <div class="modal fade" id="modal-customer-information" tabindex="-1" role="dialog" aria-hidden="true">
      <div :class="'modal-dialog ' + (step===2 || step===3 ? 'modal-lg' : '')" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title">Customer Information</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <ul class="nav nav-pills justify-content-center">
              <li class="nav-item">
                <a :class="'nav-link ' + (step===1 ? 'active' : '')" href="#" @click.prevent="step=1">Search</a>
              </li>
              <li class="nav-item">
                <a :class="'nav-link ' + (step===2 ? 'active' : '') + (!customers || !customers.length ? 'disabled' : '')" href="#" @click.prevent="step=2">Customers</a>
              </li>
              <li class="nav-item">
                <a :class="'nav-link ' + (step===3 ? 'active' : '') + (!addresses || !addresses.length ? 'disabled' : '')" href="#" @click.prevent="step=3">Addresses</a>
              </li>
              <li class="nav-item">
                <a :class="'nav-link ' + (step===4 ? 'active' : '')" href="#" @click.prevent="step=4">Form</a>
              </li>
            </ul>
          </div>

          <form v-if="step===1" @submit.prevent="searchUsersByTelephone">
            <div class="modal-body">
              <div class="form-group row mb-0">
                <label for="input-customer-telephone" class="col-sm-4 col-form-label required">Mobile number</label>
                <div class="col-sm-8">
                  <div class="input-group">
                    <input type="text" class="form-control" id="input-customer-telephone-search" v-model="shipping_address.telephone" placeholder="071---" minlength="7" maxlength="15" required>
                    <div class="input-group-append">
                      <button class="btn btn-primary" type="submit" :disabled="processing_search_telephone">
                        <i class="fas fa-circle-notch fa-spin" v-if="processing_search_telephone"></i>
                        <i class="fa fa-search" v-if="!processing_search_telephone"></i>
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div v-if="step===2" class="modal-body">
            <div class="row">
              <div v-for="(customer, k) in customers" :key="k" class="col-md-4 mb-4">
                <strong>{{ customer.name }}</strong>
                <p class="mb-0">{{ customer.telephone }}</p>
                <p class="mb-2">{{ customer.email }}</p>
                <button type="button" class="btn btn-outline-primary" @click.prevent="selectUser(customer)" :disabled="processing_search_addresses">
                  <i class="fas fa-circle-notch fa-spin" v-if="processing_search_addresses"></i>
                  Select
                </button>
              </div>
            </div>
          </div>

          <div v-if="step===3">
            <div v-if="addresses && addresses.length" class="modal-body">
              <div class="row">
                <div v-for="(address, k) in addresses" :key="k" class="col-md-4 mb-4">
                  <strong>{{ address.name }}</strong>
                  <p class="mb-0">{{ address.address_1 }}</p>
                  <p v-if="address.address_2" class="mb-0">{{ address.address_2 }}</p>
                  <p class="mb-1"><strong>{{ address.city.name }}</strong></p>
                  <p class="mb-1 small"><span class="text-muted">Tel:</span> {{ address.telephone }}</p>
                  <p class="mb-2 small"><span class="text-muted">E-mail:</span> {{ address.email }}</p>
                  <button type="button" class="btn btn-outline-primary" @click="selectAddress(address)">Use this</button>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-center">
              <button type="button" class="btn btn-outline-primary" @click.prevent="newAddress">Add a new address</button>
            </div>
          </div>

          <form v-if="step===4" @submit.prevent="saveCustomerInformation">
            <div class="modal-body">
              <div class="form-group row">
                <label for="input-customer-name" class="col-sm-2 col-form-label required">Name</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" id="input-customer-name" v-model="shipping_address.name">
                </div>
              </div>
              <div class="form-group row">
                <label for="input-customer-telephone" class="col-sm-2 col-form-label">Telephone</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" id="input-customer-telephone" v-model="shipping_address.telephone" placeholder="(optional)" minlength="7" maxlength="15">
                </div>
              </div>
              <div class="form-group row">
                <label for="input-customer-email" class="col-sm-2 col-form-label">E-mail</label>
                <div class="col-sm-10">
                  <input type="email" class="form-control" id="input-customer-email" v-model="shipping_address.email" placeholder="(optional)">
                </div>
              </div>
              <div class="form-group row">
                <label for="input-customer-address-1" class="col-sm-2 col-form-label">Address</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control mb-3" id="input-customer-address-1" v-model="shipping_address.address_1" placeholder="(optional)">
                  <input type="text" class="form-control" id="input-customer-address-2" v-model="shipping_address.address_2" placeholder="(optional)">
                </div>
              </div>
              <div class="form-group row">
                <label for="select-customer-city" class="col-sm-2 col-form-label">City</label>
                <div class="col-sm-6">
                  <select class="form-control" id="select-customer-city" v-model="shipping_address.city" @change="shipping_address.city_id=shipping_address.city.id">
                    <option value="null">(optional)</option>
                    <option v-for="(value, k) in cities" :key="k" :value="value">{{ value.name }}</option>
                  </select>
                </div>
                <div class="col-sm-4 pl-md-0">
                  <input type="text" id="input-customer-state" class="form-control" :value="shipping_address.city ? shipping_address.city.state : null" disabled>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-primary" :disabled="processing_form">
                <i class="fas fa-circle-notch fa-spin" v-if="processing_form"></i>
                Save changes
              </button>
            </div>
          </form>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import jQuery from 'jquery'
import axios from 'axios'

export default {
  name: 'SaleCustomer',
  props: [
    'cart'
  ],
  data () {
    return {
      step: 1,
      prompt_channel_save: false,
      processing_channel: false,
      processing_search_telephone: false,
      processing_search_addresses: false,
      processing_form: false,

      channels: null,
      cities: null,
      customers: null,
      addresses: null,

      shipping_address: {
        id: 0,
        name: null,
        email: null,
        telephone: null,
        address_1: null,
        address_2: null,
        city: null,
        city_id: null
      }
    }
  },
  mounted () {
    this.fetchChannels()
  },
  methods: {
    fetchChannels () {
      axios.get(process.env.URLS_POS_API + '/channels').then((response) => {
        this.channels = response.data.data
      }).catch(error => {
        let errorMessage = 'Failed to fetch channels.'
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage += ' ' + error.response.data.message
        }
        let errorDescription = (error.response && error.response.data && error.response.data.description) || null
        this.$toast.error(errorMessage, errorDescription)
      })
    },

    saveChannel () {
      this.processing_channel = true

      axios.put('/cart/' + this.cart.id + '/channel', {
        channel_id: this.cart.channel_id
      }).then((response) => {
        localStorage.setItem('channel-id', this.cart.channel_id)
        this.prompt_channel_save = false
      }).catch(error => {
        this.$toast.error(typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : 'Failed to update the channel.')
      }).finally(() => {
        this.processing_channel = false
      })
    },

    promptCustomerInformation () {
      this.shipping_address.id = this.cart ? this.cart.shipping_address.address_id : 0
      this.shipping_address.name = this.cart ? this.cart.shipping_address.name : null
      this.shipping_address.email = this.cart ? this.cart.shipping_address.email : null
      this.shipping_address.telephone = this.cart ? this.cart.shipping_address.telephone : null
      this.shipping_address.address_1 = this.cart ? this.cart.shipping_address.address_1 : null
      this.shipping_address.address_2 = this.cart ? this.cart.shipping_address.address_2 : null
      this.shipping_address.city = this.cart ? this.cart.shipping_address.city : null
      this.shipping_address.city_id = this.cart && this.cart.shipping_address.city ? this.cart.shipping_address.city.id : null

      jQuery('#modal-customer-information').modal('show').on('shown.bs.modal', function () {
        jQuery('#input-customer-telephone-search').focus()
      })

      this.fetchCities()
    },

    fetchCities () {
      this.cities = []
      axios.get('/cities').then((response) => {
        this.cities = response.data.data
      }).catch(error => {
        let errorMessage = 'Failed to fetch cities.'
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage += ' ' + error.response.data.message
        }
        let errorDescription = (error.response && error.response.data && error.response.data.description) || null
        this.$toast.error(errorMessage, errorDescription)
      })
    },

    searchUsersByTelephone () {
      if (!this.shipping_address.telephone) {
        return this.$toast.error('Please provide the telephone number')
      }

      if (this.shipping_address.telephone.length < 7 || this.shipping_address.telephone.length > 15) {
        return this.$toast.error('Telephone number must have between 7 to 15 characters')
      }

      this.processing_search_telephone = true

      axios.get(process.env.URLS_POS_API + '/customers', {
        params: {
          telephone: this.shipping_address.telephone
        }
      }).then((response) => {
        this.customers = response.data.data

        if (this.customers.length === 0) {
          this.step = 4
        } else if (this.customers.length === 1) {
          this.selectUser(this.customers[0])
        } else {
          this.step = 2
        }
      }).catch(error => {
        let errorMessage = 'Failed to search customers.'
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage += ' ' + error.response.data.message
        }
        let errorDescription = (error.response && error.response.data && error.response.data.description) || null
        this.$toast.error(errorMessage, errorDescription)
        console.log('searchUsersByTelephone', error)
      }).finally(() => {
        this.processing_search_telephone = false
      })
    },

    selectUser (customer) {
      this.shipping_address.name = customer.name
      this.shipping_address.email = customer.email
      this.shipping_address.telephone = customer.telephone

      // If a customer ID is available, fetch available addresses.
      // Otherwise, consider this as a guest.
      if (customer.id) {
        this.fetchAddresses(customer)
      } else if (typeof customer.city_id !== 'undefined') {
        this.selectAddress({
          id: 0,
          address_1: customer.address_1,
          address_2: customer.address_2,
          city_id: customer.city_id,
          city: customer.city
        })
      } else {
        this.newAddress()
      }
    },

    fetchAddresses (customer) {
      this.processing_search_addresses = true

      axios.get(process.env.URLS_POS_API + '/customers/' + customer.id + '/addresses').then((response) => {
        this.addresses = response.data.data

        if (this.addresses.length === 0) {
          this.step = 4
          this.newAddress()
        } else if (this.addresses.length === 1) {
          this.selectAddress(this.addresses[0])
        } else {
          this.step = 3
        }
      }).catch(error => {
        let errorMessage = 'Failed to fetch customer addresses.'
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage += ' ' + error.response.data.message
        }
        let errorDescription = (error.response && error.response.data && error.response.data.description) || null
        this.$toast.error(errorMessage, errorDescription)
      }).finally(() => {
        this.processing_search_addresses = false
      })
    },

    selectAddress (address) {
      this.shipping_address.id = address.id
      this.shipping_address.address_1 = address.address_1
      this.shipping_address.address_2 = address.address_2
      this.shipping_address.city_id = address.city ? address.city.id : null
      this.shipping_address.city = address.city
      this.step = 4
    },

    newAddress () {
      this.shipping_address.id = 0
      this.shipping_address.address_1 = null
      this.shipping_address.address_2 = null
      this.shipping_address.city_id = null
      this.shipping_address.city = null
      this.step = 4
    },

    saveCustomerInformation () {
      this.processing_form = true

      let data = this.shipping_address
      data['include_cart'] = true

      axios.put('/cart/' + this.cart.id + '/shipping_address', data).then((response) => {
        this.$parent.cart = response.data.data.cart

        jQuery('#modal-customer-information').modal('hide')
      }).catch(error => {
        this.$toast.error(typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : 'Failed to update the shipping address.')
      }).finally(() => {
        this.processing_form = false
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sale/partials/Customer.vue